var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "event-list clearfix",
      class: [_vm.eventDisplayType === "type-1" ? "type-1" : "", _vm.theme],
    },
    [
      _vm.loading
        ? _c("div", { staticClass: "loading-wrapper" }, [_c("loading")], 1)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.events.length && !_vm.loading,
              expression: "!events.length && !loading",
            },
          ],
          staticClass: "empty-state center",
        },
        [_vm._v("\n    No Events are available.\n  ")]
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading",
            },
          ],
          staticClass: "events-container row",
          class: ["event-direction-" + _vm.eventDirection],
        },
        _vm._l(_vm.events, function (event) {
          return _c(
            "li",
            { staticClass: "event-item clearfix" },
            [
              _vm.eventDisplayType === "type-1"
                ? _c("event-card-1", {
                    attrs: {
                      "venue-id": _vm.venueId,
                      event: event,
                      direction: _vm.eventDirection,
                      "vertical-mode": _vm.eventDirection === "vertical",
                      "button-text": _vm.buttonText,
                      "button-bg-color": _vm.buttonBgColor,
                      "button-text-color": _vm.buttonTextColor,
                      theme: _vm.theme,
                    },
                    on: { eventClick: _vm.onEventClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.eventDisplayType === "type-2"
                ? _c("event-card-2", {
                    attrs: {
                      "venue-id": _vm.venueId,
                      event: event,
                      direction: _vm.eventDirection,
                      "button-text": _vm.buttonText,
                      "button-bg-color": _vm.buttonBgColor,
                      "button-text-color": _vm.buttonTextColor,
                      theme: _vm.theme,
                    },
                    on: { eventClick: _vm.onEventClick },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.eventDisplayType === "type-3"
                ? _c("event-card-3", {
                    attrs: {
                      "venue-id": _vm.venueId,
                      event: event,
                      direction: _vm.eventDirection,
                      "button-text": _vm.buttonText,
                      "button-bg-color": _vm.buttonBgColor,
                      "button-text-color": _vm.buttonTextColor,
                      theme: _vm.theme,
                    },
                    on: { eventClick: _vm.onEventClick },
                  })
                : _vm._e(),
            ],
            1
          )
        })
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pagination-wrapper" },
        [
          _c(
            "pagination",
            {
              attrs: {
                "disable-previous": _vm.pageNumber === 1,
                "disable-next": _vm.events.length < _vm.pageSize,
              },
              on: {
                previousPage: _vm.onPreviousPage,
                nextPage: _vm.onNextPage,
              },
            },
            [
              _c("template", { attrs: { slot: "middle" }, slot: "middle" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.pagingStr) +
                    " of " +
                    _vm._s(_vm.totalEvents) +
                    " Total\n      "
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/loaders/templateLoader.js?{"loaders":{"css":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"postcss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}}],"less":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"less-loader","options":{"sourceMap":true}}],"sass":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"indentedSyntax":true,"sourceMap":true}}],"scss":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"sass-loader","options":{"sourceMap":true}}],"stylus":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}],"styl":[{"loader":"/vercel/path0/~/extract-text-webpack-plugin/loader.js","options":{"omit":1,"remove":true}},{"loader":"vue-style-loader"},{"loader":"css-loader","options":{"sourceMap":true}},{"loader":"stylus-loader","options":{"sourceMap":true}}]}}!./src/components/EventList/template.html?vue&type=template&id=b6a3aa4a&
// module id = 1049
// module chunks = 0